import React from 'react';
import './style.scss';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';

const CrossSellingProductsTitle = ({ heading, subHeading, primaryButton, secondaryButton }) => (
  <div className="csp-title-wrapper">
    <div className="csp-title">
      <h3 className="csp-title-heading">
        <Text field={heading} />
      </h3>
      <RichText field={subHeading} className="csp-title-text" />
      {(primaryButton?.value?.href || secondaryButton?.value?.href) && (
        <div className="csp-title-buttons">
          {!!primaryButton?.value?.href && (
            <Button link={primaryButton} variant="contained" color="secondary" />
          )}
          {!!secondaryButton?.value?.href && (
            <Button link={secondaryButton} variant="text" color="secondary" arrow="left" />
          )}
        </div>
      )}
    </div>
  </div>
);

export default CrossSellingProductsTitle;
